//import logger from '../../services/logger';

import React from "react";
import Simulateur from "../common/C02Data"; 
import { PageTitle } from "../common/Header";

const CarboTool = () => {

    return (
        <div className="white-background">
            <PageTitle title="CarboTool" />
            <Simulateur className="mt-3 mb-3"></Simulateur>
            <br/><br/>
        </div>
    );
};

export default CarboTool;